<template>
  <div :class="{ 'upload-data': uploadData }" class="update-container update-problem">
    <circle-loader v-if="uploadData" size="xlarge" :indeterminate="true" />

    <div v-if="showHeader" class="update-problem__header">
      <div :class="problemData.status" class="status__key">{{ getStatus(problemData.status) }}</div>
      <div class="buttons">
        <div class="attachments event" @click="onAddNewEvent()">Создать мероприятие</div>
        <div class="attachments" @click="onCloseAttachments()">Вложение</div>
      </div>
    </div>

    <div v-if="!hideTabs" class="content-tabs">
      <div :class="{ 'active-tab': activeTab === 'COMMON' }" class="tab" @click="onClickTab('COMMON')">
        <span>Общее сведения</span>
      </div>
      <div
        v-if="problemData.events && problemData.events.length > 0"
        :class="{ 'active-tab': activeTab === 'EVENTS' }"
        class="tab"
        @click="onClickTab('EVENTS')"
      >
        <span>Мероприятия</span>
      </div>
    </div>

    <div v-show="activeTab === 'COMMON'" class="content-wrapper">
      <div class="row">
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <div class="general-header">
                <div class="title">Описание проблемы</div>
                <div class="info">{{ problemTypes[problemData.type] }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="status-modal">
                <span @click="onChangeStatus()">{{ selectedStatus[problemData.status] }}</span>
              </div>
            </div>
            <div class="col-4">
              <form-select-custom
                :input-model="problemData.priority"
                :input-options="prioritetOptions"
                :enable-color-info="true"
                fieldname="problemData.priority"
                label="Приоритет"
                @update="updateData"
              />
            </div>
            <div class="col-4">
              <forms-data :input-model="problemData.disposal_period" placeholder="Крайний срок" label="Крайний срок" />
              <div class="form-cover">
                <div class="reduct-date" @click="onOpenSelectDate()"></div>
              </div>
            </div>
            <div class="col-4">
              <form-info :info="problemData.created_at" title="Создана" />
            </div>
            <div class="col-12">
              <forms-data
                label="Комментарий"
                placeholder="Комментарий"
                fieldname="problemData.comment"
                :input-model="problemData.comment"
                tag-type="textarea"
                :keymonitor="onKeyUpTextarea"
                @update="updateData"
              />
              <div class="textarea-count">{{ problemData.comment ? problemData.comment.length : 0 }}/500</div>
            </div>
            <div class="col-12">
              <div class="general-header">
                <div class="title">Действия</div>
                <div class="info">История операций по текущей проблеме</div>
              </div>
              <form-info
                v-for="problemLog in problemLogs"
                :key="problemLog.id"
                :title="problemLog.created_at"
                :info="problemLog.message"
                :with-arrow="['problems_document_attached', 'problems_photo_attached'].includes(problemLog.event_code)"
                @click="problemLogHandler(problemLog.event_code, problemLog.meta)"
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-12">
              <problem-entity :info="problemData.identifier" :router-link="toProblemEntityPath" />
            </div>
          </div>
          <map-with-address
            :container-state="problemData"
            :disable-inputs="true"
            :map-configs="mapConfigs"
            :keymonitor="keymonitor"
            :update="updateData"
            address-input-name="location"
            fieldname="problemData"
          />
        </div>
      </div>
    </div>

    <div v-show="activeTab === 'EVENTS'" class="content-wrapper">
      <nested-container
        :table-columns="eventsColumns"
        :table-data="problemData.events"
        :elements="nestedEvents"
        :update="updateData"
        :keymonitor="keymonitor"
        :before-change-header="changeHeader"
        container-type="special"
      />
    </div>

    <div :class="{ 'right-menu__active': isActiveSelectDate }" class="right-menu disposal_date">
      <div class="right-menu__content">
        <div class="right-menu-header">
          <div class="right-menu-header__title">Срок выполнения</div>
          <div class="right-menu-header__close-menu" @click="onCloseSelectDate()"></div>
        </div>
        <div class="right-list">
          <div class="row">
            <div class="col-12">
              <p>Укажите дату и время решения проблемы</p>
            </div>
            <div class="col-6">
              <forms-data
                :input-model="disposal__date"
                label="Дата"
                placeholder="Дата"
                fieldname="disposal__date"
                @update="updateData"
              />
            </div>
            <div class="col-6">
              <forms-data
                :input-model="disposal__time"
                label="Время"
                placeholder="Время"
                fieldname="disposal__time"
                @update="updateData"
              />
            </div>
            <div class="col-12">
              <date-picker
                v-model="disposal__date__pick"
                :inline="true"
                :not-before="disposal_period_set"
                lang="ru"
                @change="onChangeDate($event)"
              />
            </div>
          </div>
        </div>
        <div class="right-menu-footer">
          <regular-button type="button" :rounded="true" @click="onSelectDate()">Изменить</regular-button>
        </div>
      </div>
    </div>

    <div :class="{ 'right-menu__active': isActiveAttachments }" class="right-menu attachments">
      <div class="right-menu__content">
        <div class="right-menu-header">
          <div class="right-menu-header__title">Вложение</div>
          <div class="right-menu-header__close-menu" @click="onCloseAttachments()"></div>
        </div>
        <div class="right-list">
          <div class="attachments-photo">
            <div class="attachments-main-photo">
              <div v-if="attachments.images.length === 0" class="pseudo-image"></div>
              <img v-if="attachments.images.length > 0" :src="activeImage.url" alt="" @click="showLightbox" />
              <span v-if="attachments.images.length > 0" class="delete-image" @click="onDeleteImage"></span>
              <span v-if="attachments.images.length > 0" class="show-photo-gallery" @click="showLightbox"></span>
            </div>

            <div v-if="attachments.images.length > 0 && isActiveAttachments" class="attachments-photo-list">
              <div class="slick-arrow slick-prev" @click="handleSliderPrev"></div>
              <div class="slick-arrow slick-next" @click="handleSliderNext"></div>
              <slick ref="slider" :options="sliderOptions">
                <div
                  v-for="(image, imageIndex) in attachments.images"
                  :key="imageIndex"
                  :class="{ 'active-image': image.active }"
                  class="image"
                  @click="onClickImage(image)"
                >
                  <img :src="image.url" alt="" />
                </div>
              </slick>
            </div>
          </div>
          <div class="attachments-files">
            <div v-for="(file, index) in attachments.files" :key="index" class="attachments-files-list">
              <form-info :title="file.title" :info="file.origin_filename" class="form-info" />
              <div class="file-buttons">
                <div class="delete-button" @click="onDeleteFile(file)"></div>
                <a :download="file.url" class="download-button"></a>
              </div>
            </div>
          </div>
        </div>
        <div class="right-menu-footer" @click="onAddFile()">
          <regular-button type="button" :rounded="true">
            Загрузить файл
            <input ref="file" type="file" style="display:none" @change="onChangeFile($event)" />
          </regular-button>
        </div>
      </div>
    </div>

    <lightbox id="attachements-lightbox" ref="lightbox" :images="galleryPhotos" />
    <lightbox id="problem-log-image" ref="problemLogLightbox" :images="problemLogImage" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Slick from "vue-slick/src/slickCarousel.vue";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Lightbox from "vue-my-photos/src/lightbox.vue";

import FormSelectCustom from "../../../../components/forms/FormSelectCustom";
import FormsData from "../../../../components/forms/FormData";
import FormInfo from "../../../../components/forms/FormInfo";
import { saveAsFile } from "../../../../common";
import NestedContainer from "../../../../components/NestedContainer";
import MapWithAddress from "../../../../components/MapWithAddress";
import CircleLoader from "../../../../components/CircleLoader";
import RegularButton from "../../../../components/RegularButton";

import ProblemEntity from "./ProblemEntity";

export default {
  name: "UpdateProblem",
  components: {
    FormSelectCustom,
    FormsData,
    FormInfo,
    NestedContainer,
    Slick,
    DatePicker,
    MapWithAddress,
    ProblemEntity,
    Lightbox,
    CircleLoader,
    RegularButton
  },
  data() {
    return {
      showHeader: true,
      activeTab: "COMMON",
      isActiveSelectDate: false,
      hideTabs: false,
      isActiveAttachments: false,
      disposal_period_set: new Date(),
      disposal__time: null,
      disposal__date: null,
      disposal__date__pick: null,
      problemData: {
        events: []
      },
      problemLogs: {},
      selectedStatus: {
        OPEN: "Взять в работу",
        IN_WORK: "Проблема решена",
        RESOLVED: "Переоткрыть"
      },
      uploadData: true,
      attachments: {
        images: [],
        files: []
      },
      problemLogImage: [],
      activeImage: {},
      sliderOptions: {
        slidesToShow: 4,
        arrows: false,
        infinite: false
      },
      inputOptions: [
        {
          text: "Открыта",
          value: "OPEN"
        },
        {
          text: "В работе",
          value: "IN_WORK"
        },
        {
          text: "Решена",
          value: "RESOLVED"
        }
      ],
      prioritetOptions: [
        {
          text: "Обычный",
          value: "USUAL"
        },
        {
          text: "Высокий",
          value: "HIGH"
        },
        {
          text: "Низкий",
          value: "LOW"
        }
      ],
      priorityDic: {
        USUAL: "Обычный"
      },
      statusDic: {
        OPEN: "ОТКРЫТА"
      },
      objTypeFrontPathsDict: {
        CONTAINER_WASTE_AREA: "/containers/container/update/",
        CHAMBER_WASTE_AREA: "/containers/chamber/update/",
        COLLECTION_WASTE_AREA: "/containers/collection/update/",
        SPECIAL_WASTE_AREA: "/containers/special/update/",
        FACILITY: "/waste-management-facilities/update/",
        WASTE_SOURCE: "/waste-sources/update/",
        WASTE_DUMP: "",
        OPERATOR: "",
        CONTRACT: "",
        NATURAL_PERSON: "/waste-handlers/natural-person/update/",
        JURIDICAL_PERSON: "/waste-handlers/juridical-person/update/"
      },
      toProblemEntityPath: "",
      errors: {
        comment: false
      },
      mapConfigs: {
        options: {
          scrollWheelZoom: "center"
        },
        zoom: 13,
        center: process.env.VUE_APP_MAP_CENTER.split(","),
        url: `${window.location.protocol}//c.tile.openstreetmap.org/{z}/{x}/{y}.png`
      },
      eventState: {
        responsible_person: "",
        funding_source: "BUDGET",
        event_type: "REPAIR",
        note: "",
        replaced_containers: 0,
        container_type: "STANDARD",
        starts_at: "",
        ends_at: ""
      },
      eventTypeOptions: [
        {
          value: "REPAIR",
          text: "Ремонт"
        },
        {
          value: "REPLACEMENT",
          text: "Замена"
        },
        {
          value: "ELIMINATION",
          text: "Ликвидация"
        },
        {
          value: "CREATION",
          text: "Создание"
        },
        {
          value: "ROOF",
          text: "Установка навеса / крыши"
        },
        {
          value: "FENCE",
          text: "Установка ограждения"
        },
        {
          value: "GROUND",
          text: "Устройство основания"
        },
        {
          value: "CONTAINER_REPLACEMENT",
          text: "Замена контейнеров / бункеров"
        }
      ],
      containerTypeOptions: [
        {
          value: "STANDARD",
          text: "Стандартный"
        },
        {
          value: "EURO",
          text: "Евро"
        },
        {
          value: "BURIED",
          text: "Заглубленный"
        },
        {
          value: "SEPARATE",
          text: "Для раздельного сбора"
        },
        {
          value: "BUNKER",
          text: "Бункер"
        }
      ],
      fundingSourceOptions: [
        {
          value: "BUDGET",
          text: "Бюджет"
        },
        {
          value: "COMERCIAL",
          text: "Не бюджет"
        }
      ],
      eventType: "",
      eventError: {
        responsible_person: false,
        starts_at: false,
        ends_at: false,
        note: false
      }
    };
  },
  computed: {
    ...mapState(["problemTypes", "problemObjectTypes"]),
    eventsColumns() {
      return [
        {
          name: "Тип мероприятия",
          key: "event_type",
          dir: this.eventTypeOptions
        },
        { name: "Ответственный", simple: true, key: "responsible_person" },
        {
          name: "Срок проведения",
          key: "starts_at",
          date: ["starts_at", "ends_at"]
        }
      ];
    },
    nestedEvents() {
      return [
        {
          elementType: "FormSelect",
          value: this.eventState.event_type,
          fieldname: "eventState.event_type",
          label: "Тип мероприятия",
          inputOptions: this.eventTypeOptions,
          twoLevel: {
            CONTAINER_REPLACEMENT: [
              {
                elementType: "FormSelect",
                value: this.eventState.container_type,
                fieldname: "eventState.container_type",
                label: "Тип заменяемых контейнеров",
                inputOptions: this.containerTypeOptions
              },
              {
                elementType: "FormData",
                value: this.eventState.replaced_containers,
                fieldname: "eventState.replaced_containers",
                label: "Количество, шт",
                placeholder: "Количество заменяемых контейнеров",
                checkInputFunction: "setContainerCount"
              }
            ]
          }
        },
        {
          elementType: "FormData",
          value: this.eventState.responsible_person,
          fieldname: "eventState.responsible_person",
          label: "Ответственный",
          placeholder: "Ответственный",
          hasError: true,
          errorInfo: "5-250 символов",
          error: this.eventError.responsible_person
        },
        {
          elementType: "FormSelect",
          value: this.eventState.funding_source,
          fieldname: "eventState.funding_source",
          label: "Источник финансирования",
          inputOptions: this.fundingSourceOptions
        },
        {
          elementType: "FormMultiDate",
          value: {
            startDate: this.eventState.starts_at,
            endDate: this.eventState.ends_at
          },
          fieldname: {
            startDate: "eventState.starts_at",
            endDate: "eventState.ends_at"
          },
          hasErrors: {
            startDate: "starts_at",
            endDate: "ends_at"
          },
          errors: {
            startDate: this.eventError.starts_at,
            endDate: this.eventError.ends_at
          },
          label: "Срок проведения",
          errorInfo: "Введите срок проведения"
        },
        {
          elementType: "FormData",
          value: this.eventState.note,
          fieldname: "eventState.note",
          label: "Комментарий",
          placeholder: "Комментарий",
          hasError: true,
          errorInfo: "5-250 символов",
          error: this.eventError.note
        }
      ];
    },
    galleryPhotos: {
      get() {
        return this.attachments.images
          .filter(photo => typeof photo.url !== "undefined")
          .map(photo => ({
            name: photo.url,
            alt: photo.origin_filename,
            id: photo.id
          }));
      }
    }
  },
  mounted() {
    const problemId = this.$route.params.problemId;

    const requests = [];

    requests.push(
      this.getProblem(problemId).then(res => {
        const resData = res && res.data ? res.data : null;

        if (resData) {
          this.getProblemEntityPath(resData);

          if (resData.disposal_period) {
            const disDate = new Date(resData.disposal_period);
            const disMinutes = `0${disDate.getMinutes()}`.slice(-2);
            const disHours = `0${disDate.getHours()}`.slice(-2);

            this.disposal__date__pick = disDate;
            this.disposal__time = `${disHours}:${disMinutes}`;
            this.disposal__date = `${disDate.toLocaleDateString("ru")}`;
            resData.disposal_period = `${this.disposal__date} ${this.disposal__time}`;
          }

          if (resData.attachments.length > 0) {
            resData.attachments.map(el => {
              if (el.kind === "IMAGE") {
                el.active = false;
                this.attachments.images.push(el);
                return el;
              }
              el.title = this.getFileTitle(el);
              this.attachments.files.push(el);
              return el;
            });
          }

          if (this.attachments.images.length > 0) {
            this.attachments.images[0].active = true;
            this.activeImage = this.attachments.images[0];
          }

          if (resData.created_at) {
            resData.created_at = new Date(resData.created_at).toLocaleDateString("ru");
          }

          this.problemData = {
            ...this.problemData,
            ...resData
          };

          this.$root.$emit("onChangeHeader", {
            upTitle: "Проблемы",
            mainTitle: `Проблема ${resData.id}`
          });
        }
      })
    );

    requests.push(
      this.getSource({
        url: `/api/problems/${problemId}/logs/`
      }).then(problemLogs => {
        this.problemLogs = problemLogs.data.results.map(log => {
          log.created_at = moment(log.created_at).fromNow();
          return log;
        });
      })
    );

    Promise.all(requests).then(() => {
      this.uploadData = false;
    });

    this.$root.$on("onSaveProblem", () => {
      const _problemData = JSON.parse(JSON.stringify(this.problemData));
      if (_problemData.comment && _problemData.comment.length > 0 && _problemData.comment.length < 5) {
        this.errors.comment = true;
        return;
      }
      if (_problemData.comment && _problemData.comment.length === 0) {
        _problemData.comment = null;
      }
      _problemData.attachments = _problemData.attachments.map(el => el.id);
      if (this.disposal__date) {
        const splittedDate = this.disposal__date.split(".");
        _problemData.disposal_period = `${splittedDate[1]}.${splittedDate[0]}.${splittedDate[2]} ${this.disposal__time}`;
        _problemData.disposal_period = new Date(_problemData.disposal_period).toISOString();
      }
      this.updateProblem({
        id: problemId,
        data: _problemData
      }).then(res => {
        if (res.status === 200) {
          this.$router.push({ name: "ProblemsTable" });
        }
      });
    });

    // onCancelNestedContainer
    this.$root.$on("onCancelNestedContainer", () => {
      this.hideTabs = false;
      this.$root.$emit("nestedContainerDefault");
      this.eventState = {
        responsible_person: "",
        funding_source: "BUDGET",
        event_type: "REPAIR",
        note: "",
        replaced_containers: 0,
        container_type: "STANDARD",
        starts_at: "",
        ends_at: ""
      };
      this.eventType = "";

      if (this.problemData.events.length > 0) {
        this.activeTab = "EVENTS";
      } else {
        this.activeTab = "COMMON";
      }
    });
    // onSaveNestedContainer
    this.$root.$on("onSaveNestedContainer", () => {
      const newEvent = JSON.parse(JSON.stringify(this.eventState));
      if (this.onCheckRequires(newEvent)) {
        return;
      }
      if (newEvent.note.length === 0) {
        newEvent.note = null;
      }
      if (this.eventType === "reduct") {
        this.problemData.events = this.problemData.events.map(el => {
          if (el.own_id === newEvent.own_id) {
            el = newEvent;
          }
          return el;
        });
      } else {
        this.problemData.events.push(newEvent);
      }
      this.eventState = {
        responsible_person: "",
        funding_source: "BUDGET",
        event_type: "REPAIR",
        note: "",
        replaced_containers: 0,
        container_type: "STANDARD",
        starts_at: "",
        ends_at: ""
      };
      this.hideTabs = false;
      this.eventType = "";
      this.$root.$emit("nestedContainerDefault");
      const params = {
        upTitle: "Проблемы",
        mainTitle: `Проблема ${this.problemData.id}`
      };
      this.$root.$emit("onChangeHeader", params);
    });

    this.$root.$on("nestedContainerAdd", () => {
      this.showHeader = false;
    });
    this.$root.$on("nestedContainerDefault", () => {
      this.showHeader = true;
    });
  },
  beforeDestroy() {
    this.$root.$off("onSaveProblem");
    this.$root.$off("onCancelNestedContainer");
    this.$root.$off("nestedContainerAdd");
    this.$root.$off("nestedContainerDefault");
  },
  methods: {
    ...mapActions(["getProblem", "updateProblem", "uploadImage", "getSource"]),
    onKeyUpTextarea() {
      this.errors.comment = false;
    },
    onAddNewEvent() {
      this.activeTab = "EVENTS";
      this.changeHeader();
      this.$root.$emit("nestedContainerAdd");
    },
    changeHeader(elem) {
      this.hideTabs = true;
      if (elem) {
        this.eventState = JSON.parse(JSON.stringify(elem));
        this.eventType = "reduct";
      } else {
        this.eventState.own_id = Math.random();
      }
      this.$root.$emit(
        "onChangeHeader",
        {
          upTitle: "Проблемы",
          mainTitle: "Проблема"
        },
        "nestedContainer"
      );
    },
    onClickTab(type) {
      this.activeTab = type;
    },
    onChangeStatus() {
      if (this.problemData.status === "OPEN") {
        this.problemData.status = "IN_WORK";
      } else if (this.problemData.status === "IN_WORK") {
        this.problemData.status = "RESOLVED";
      } else {
        this.problemData.status = "OPEN";
      }
    },
    onSelectDate() {
      this.problemData.disposal_period = `${this.disposal__date} ${this.disposal__time}`;
      this.onCloseSelectDate();
    },
    onOpenSelectDate() {
      const date = new Date();
      if (!this.disposal__date__pick && !this.disposal__date && this.disposal__time) {
        this.disposal__date__pick = date;
        this.disposal__date = date.toLocaleDateString("ru");
        this.disposal__time = `${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`;
      }
      this.onCloseSelectDate();
    },
    onChangeDate(date) {
      this.disposal__date = new Date(date).toLocaleDateString("ru");
    },
    onCloseSelectDate() {
      this.isActiveSelectDate = !this.isActiveSelectDate;
    },
    onDeleteFile(file) {
      this.problemData.attachments = this.problemData.attachments.filter(el => el.id !== file.id);
      this.attachments.files = this.attachments.files.filter(el => el.id !== file.id);
    },
    getFileTitle(file) {
      if (file.size < 10000) {
        file.size = `${Number(file.size / 1024).toFixed(2)}kb`;
      } else {
        file.size = `${Number(file.size / 1024 / 1024).toFixed(2)}mb`;
      }
      return `Загружен ${new Date(file.created_at).toLocaleDateString("ru")} - ${file.size}`;
    },
    onDeleteImage() {
      this.attachments.images = this.attachments.images.filter(image => image.id !== this.activeImage.id);
      this.problemData.attachments = this.problemData.attachments.filter(image => image.id !== this.activeImage.id);
      if (this.attachments.images.length > 0) {
        this.attachments.images.map(image => {
          image.active = false;
          return image;
        });
        this.attachments.images[0].active = true;
        this.activeImage = this.attachments.images[0];
      } else {
        this.activeImage = {};
      }
    },
    onCloseAttachments() {
      this.isActiveAttachments = !this.isActiveAttachments;
      if (this.isActiveAttachments) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "inherit";
      }
    },
    onClickImage(image) {
      this.activeImage = image;
      this.attachments.images = this.attachments.images.map(el => {
        el.active = false;
        if (el.id === image.id) {
          el.active = true;
        }
        return el;
      });
    },
    onAddFile() {
      this.$refs.file.click();
    },
    onChangeFile(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      const rules = {
        images: ["png", "jpg", "jpeg", "gif"],
        files: ["pdf", "doc", "docx", "xls", "xlsx"]
      };
      if (!file) {
        return;
      }
      const fileExtension = file.name.split(".").pop();
      let fileKind = "";
      if (rules.images.indexOf(fileExtension) > -1) {
        fileKind = "IMAGE";
      } else if (rules.files.indexOf(fileExtension) > -1) {
        fileKind = "FILE";
      } else {
        alert("Not allowed extension");
        return;
      }
      if (file.size > 20971520) {
        alert("File is too large");
        return;
      }

      formData.append("files", file);
      this.uploadImage(formData).then(response => {
        const uploadData = response.data[0];
        this.problemData.attachments.push(uploadData);
        if (fileKind === "IMAGE") {
          this.attachments.images = this.attachments.images.map(image => {
            image.active = false;
            return image;
          });
          uploadData.active = true;
          this.activeImage = uploadData;
          this.attachments.images.push(uploadData);
        } else {
          uploadData.origin_filename = file.name;
          uploadData.size = file.size;
          uploadData.created_at = new Date().toISOString();
          uploadData.title = this.getFileTitle(uploadData);
          this.attachments.files.push(uploadData);
        }
      });
      e.target.value = "";
    },
    getDate(date) {
      if (date) {
        return new Date(date).toLocaleDateString("ru");
      }
      return "N/O";
    },
    getPriority(priority) {
      return this.prioritetOptions.find(el => el.value === priority).text;
    },
    getStatus(status) {
      if (!status) {
        return "";
      }
      return this.inputOptions.find(el => el.value === status).text;
    },
    getObjectType(type) {
      return this.problemObjectTypes[type];
    },
    keymonitor() {
      this.eventError = {
        responsible_person: false,
        starts_at: false,
        ends_at: false,
        note: false
      };
    },
    updateData(data) {
      const target = data.fieldname.split(".");
      const dataType = typeof data.value === "undefined";

      if (target.length === 1) {
        this[target[0]] = dataType ? null : data.value;
      }
      if (target.length === 2) {
        dataType ? this.$set(this[target[0]], target[1], null) : this.$set(this[target[0]], target[1], data.value);
      }
    },
    onCheckRequires(data) {
      const requires = [];
      if (!data.responsible_person && data.responsible_person.length < 5) {
        this.eventError.responsible_person = true;
        requires.push("responsible_person");
      }
      if (data.starts_at.length === 0) {
        this.eventError.starts_at = true;
        requires.push("starts_at");
      }
      if (data.ends_at.length === 0) {
        this.eventError.ends_at = true;
        requires.push("ends_at");
      }
      if (data.note && data.note.length > 0) {
        if (data.note < 5) {
          this.eventError.note = true;
          requires.push("note");
        }
      }
      return requires.length > 0;
    },
    showLightbox() {
      const imageName = this.activeImage.url;

      this.$refs.lightbox.show(imageName);
    },
    showProblemLogLightbox() {
      this.$refs.problemLogLightbox.show();
    },
    handleSliderPrev() {
      this.$refs.slider.prev();
    },
    handleSliderNext() {
      this.$refs.slider.next();
    },
    problemLogHandler(eventCode, meta) {
      switch (eventCode) {
        case "problems_photo_attached":
          this.problemLogImage = [];
          this.problemLogImage.push({
            name: meta.link,
            alt: meta.link !== undefined ? meta.filename : "Фотография удалена",
            id: "currentProblemLogImage"
          });
          this.showProblemLogLightbox();
          break;
        case "problems_document_attached":
          saveAsFile(meta.link, meta.filename);
          break;
      }
    },
    getProblemEntityPath({ object_type, object_url }) {
      if (typeof this.objTypeFrontPathsDict[object_type] !== undefined) {
        const problemEntityFrontUrl = this.objTypeFrontPathsDict[object_type];
        if (typeof object_url.match(/\d+/)[0] !== "undefined") {
          const problemEntityId = object_url.match(/\d+/)[0];
          this.toProblemEntityPath = `/terr-schema${problemEntityFrontUrl}${problemEntityId}`;
        }
      }
    }
  }
};
</script>
